<th><img src="{{imageUrl}}"></th>
<th>{{title}}</th>
<th>{{subtitle}}</th>
<th>{{formatDate timestamp}}</th>
<td class="tools">
	<i class="icon-pencil edit" title="Edit" data-id="{{id}}"></i>
	<i class="icon-trash delete" title="Delete"></i>
</td>
